import { format as formatDate } from 'date-fns/format';
import { parseISO } from 'date-fns/parseISO';
import { useGetSalesMonthly } from '../../../../api/dashboardsService';
import {
  MBox,
  MChart,
  MSkeleton,
  MText,
} from '../../../../components/Monetize';
import { sortDateByAscendingOrder } from '../../../../utils';
import { salesChartOptions } from './chartOptions';

interface SalesChartProps {
  currency: string;
}

export const SalesChart = ({ currency }: SalesChartProps) => {
  const { isLoading, data: sales } = useGetSalesMonthly(
    { query: { currency } },
    {
      select: (data) => ({
        series: [
          {
            name: 'sales-series',
            data: sortDateByAscendingOrder(data.monthlySales, 'yearMonth')
              ?.slice(-12)
              .map(
                ({
                  yearMonth,
                  amount,
                }: {
                  yearMonth: string;
                  amount: number;
                }) => ({
                  x: formatDate(parseISO(yearMonth), 'MMM'),
                  y: amount,
                }),
              ),
          },
        ],
      }),
    },
  );

  const chartOptions = salesChartOptions(currency);

  return (
    <MBox>
      <MText fontSize="lg" fontWeight="bold">
        Sales
      </MText>
      {isLoading ? (
        <MSkeleton height={300} />
      ) : (
        <MChart
          key={currency}
          options={chartOptions}
          series={sales?.series || []}
          height={300}
        />
      )}
    </MBox>
  );
};
